export function areSetsEqual(setA: Set<unknown>, setB: Set<unknown>) {
  return setA.size === setB.size && [...setA].every((x) => setB.has(x));
}
